const viewLibrary = {};

viewLibrary['display'] = require('./display').default



export default viewLibrary